/* eslint-disable no-useless-catch */
import { API } from "../api";
import {
  PAYMENT_TRANSACTIONS,
  GENERATE_MERCHALINK_PAYMENT_URL
} from "../constants/url.constant";

// Actions constants
export const GET_PAYMENT_TRANSACTIONS = "GET_PAYMENT_TRANSACTIONS";

export const generatePaymentURL = (data) => {
  return API.post(PAYMENT_TRANSACTIONS, data);
};

export const generateMerchalinkPaymentURL = (data) => {
  return API.post(GENERATE_MERCHALINK_PAYMENT_URL, data);
};

export const getPaymentURL = (data) => {
  return API.post(`${PAYMENT_TRANSACTIONS}/url`, data);
};

export const getAllPaymentTransactions = (params) => {
  return async (dispatch) => {
    try {
      const res = await API.get(PAYMENT_TRANSACTIONS, {
        params
      });
      dispatch({
        type: GET_PAYMENT_TRANSACTIONS,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getPaymentTransactionDetail = (referenceId) => {
  return API.get(`${PAYMENT_TRANSACTIONS}/${referenceId}`);
};

export default function reducer(
  state = { columns: [], rows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_PAYMENT_TRANSACTIONS:
      return {
        ...state,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
